var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"item-card"},[_c('content-line',{attrs:{"font-icon":"","icon":"screen_share","text":_vm.title}}),_c('video-container',{attrs:{"participant":_vm.hostParticipant}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }